import Relay from 'react-relay';

export default class EnqueueOverdueBillsFetchJob extends Relay.Mutation {
    getMutation() {
        return Relay.QL`mutation { enqueueOverdueBillsFetchJob }`;
    }

    getVariables() {
        const { organisationId, runStitek } = this.props;
        return { organisationId, runStitek };
    }

    getFatQuery() {
        return Relay.QL`
          fragment on EnqueueOverdueBillsFetchJobPayload {
            job { id, realId, status }
          }
        `;
    }

    getConfigs() {
        return [{ type: 'REQUIRED_CHILDREN', children: [
            Relay.QL`
              fragment on EnqueueOverdueBillsFetchJobPayload { job { id, realId, status } }
            `
        ] }];
    }
}


